import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import {
  organizationListParams,
  organizationListQueryOptions,
  organizationListSearchSchema,
  OrganizationsListPage,
} from '@/features/organizations';

export const Route = createFileRoute('/_authed/organizations/')({
  staticData: { tours: ['platform.organizations.list'] },
  // Typed input, so the nav, the overview card and the detail page's back link can link here
  // without spelling out every list param indexSearchSchema declares.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    organizationListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...organizationListQueryOptions(organizationListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // A filter, sort or page change on the list itself must not wait for the fetch: the URL
    // would lag behind, and a second pick in the filter would build on the stale filters.
    if (cause !== 'stay') await prefetch;
  },
  component: OrganizationsListPage,
});
